module.exports = __webpack_public_path__ + "img/skull_bj.302f3f05.png";